import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { ApiService } from '../../../shared/services/api.service'
import { Collection } from '../../../shared/interfaces/collection.interface'
import hash from 'object-hash'
import { Color } from '../../../shared/interfaces/color.interface'
import { Title } from '@angular/platform-browser'
import {ColorService} from '../../../shared/services/color.service'

@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit {

  loading = true
  collection: Collection
  oldCollectionHash: string
  confirmShared: boolean
  moreDialogVisible = false
  format = 'hex'
  formats = ['hex', 'rgb']

  constructor(
    private title: Title,
    private router: Router,
    private route: ActivatedRoute,
    private colorService: ColorService,
    private apiService: ApiService) {
  }

  ngOnInit() {
    window.scrollTo(0, 0)

    this.route.params.subscribe(p => {
      this.apiService.getCollection(p.collectionId)
        .subscribe((c: Collection) => {
          this.collection = c
          this.oldCollectionHash = hash(c)
          this.loading = false
          this.updateTitle()
        })
    })

    setInterval(() => {
      const h = hash(this.collection)
      if (h !== this.oldCollectionHash) {
        this.collectionChanged()
        this.oldCollectionHash = h
      }
    }, 1000)
  }

  switchFormat() {
    this.format = this.formats[(this.formats.indexOf(this.format) + 1) % this.formats.length]
  }

  collectionChanged() {
    const saveCollection = {
      ...this.collection,
      colors: this.collection.colors.map(c => {
        const fCol = this.colorService.parseColor(c.color)
        if (fCol) {
          const hex = this.colorService.toFormat(fCol, 'hex')
          return {
            ...c,
            color: hex
          }
        } else {
          return c
        }
      })
    }

    this.apiService
      .patchCollection(saveCollection)

    this.updateTitle()
  }

  updateTitle() {
    this.title.setTitle(this.collection.title + ' - Palettes')
  }

  addColor() {
    this.collection.colors.push({
      title: 'New color',
      color: '#dadada'
    })
  }

  newCollection() {
    this.apiService
      .postCollection({ title: 'New Palette', colors: [] })
      .subscribe((c: Collection) => this.router.navigate(['/' + c.id]))
  }

  forkCollection() {
    this.apiService
      .postCollection({ title: 'Copy of ' + this.collection.title, colors: this.collection.colors })
      .subscribe((c: Collection) => this.router.navigate(['/' + c.id]))
  }

  onColorDeleted(c: Color) {
    const i = this.collection.colors.indexOf(c)
    this.collection.colors.splice(i, 1)
  }

  shareButtonClicked() {
    this.confirmShared = true
    setTimeout(() => {
      this.confirmShared = false
    }, 2000)
  }

  showMore() {
    this.moreDialogVisible = true
  }

  dialogClosed() {
    this.moreDialogVisible = false
  }

  getBrightness(color: string) {
    return this.colorService.getBrightness(color)
  }

  get shareLink() {
    return `http://palettes.pxsnake.de/${this.collection.id}`
  }

  get primaryColor(): string {
    if (this.collection.colors.length < 1) {
      return null
    } else {
      return this.collection.colors[0].color
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/collection/containers/collection/collection.component.ts